export default __webpack_public_path__ + "static/Fed-Up-c8c152aef1617c925ff70491d14186ee.mp3";